import { render, staticRenderFns } from "./BlocoAlertaVisualizarMonitoramentoSocioambiental.vue?vue&type=template&id=709c1483&scoped=true&lang=pug"
import script from "./BlocoAlertaVisualizarMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoAlertaVisualizarMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoAlertaVisualizarMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=709c1483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c1483",
  null
  
)

export default component.exports